module.exports = __webpack_public_path__ + "img/IS621214-0630.f54ab4f3.png";